import React from 'react'

import { BorderLoader } from '@/components/ui/loaders/border-loader'

import * as S from './button.styled'
import type { ButtonProps } from './button.types'

export const Button = ({
  children,
  use = 'primary',
  size = 'medium',
  type = 'button',
  disabled = false,
  loading = false,
  onlyBox = false,
  onlyCircle = false,
  compact = false,
  active = false,
  onClick,
  ...rest
}: ButtonProps) => {
  const overrideDisabled = loading
  const isDisabled = disabled || overrideDisabled

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isDisabled) {
      e.preventDefault()
      return
    }
    onClick?.(e)
  }

  return (
    <S.Button
      {...rest}
      type={type}
      $use={use}
      $size={size}
      $onlyBox={onlyBox}
      $onlyCircle={onlyCircle}
      $compact={compact}
      $overrideDisabled={overrideDisabled}
      disabled={isDisabled}
      data-component-id="Button"
      data-active={active}
      onClick={handleClick}
    >
      <S.ChildrenWrapper data-button-children-wrapper>{children}</S.ChildrenWrapper>
      {loading && <BorderLoader data-button-loader align="absolute-center" size={size} />}
    </S.Button>
  )
}
